import { C8Node } from "csi/typings";
import AccommodateScrollBarBox from "designSystem/components/box/AccommodateScrollBarBox";
import { Box, DataGrid, DataGridCardProps, FlexColumn, FlexRowCenter } from "designSystem/index";
import { grey, white } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import PPProductCard, { PPProductCardSkeleton } from "../NewProductPresentation/PPProductCard";
import PPProductSlimCard from "../NewProductPresentation/PPProductSlimCard";
import { ProductGalleryStoreContext } from "../NewProductPresentation/ProductGalleryStore";
import ColorViolationSingleItem, { ColorViolationSingleItemProps } from "./ColorViolationSingleItem";
import PPResolution from "./PPResolution";
import { usePPValidationStore } from "./PPValidationStore";

const PPProductCardForValidation: FunctionComponent<DataGridCardProps<C8Node>> = observer((props) => {
	const { activeCardUrl } = usePPValidationStore();
	const isActive = activeCardUrl === props.id;

	return (
		<Box
			bgcolor={white[50]}
			m={2}
			paddingTop={0}
		>
			{isActive ? (
				<PPProductCard
					disableSwitchNodeImages
					hideMoreMenu
					{...props}
				/>
			)
				: (
					<PPProductSlimCard
						disableSwitchNodeImages
						{...props}
					/>
				)}
		</Box>
	);
});

const PPGallery = observer(() => {
	const { galleryStore, store, setActiveCardUrl, activeCardUrl } = usePPValidationStore();

	const _onClickCardItem = (item: C8Node) => {
		setActiveCardUrl(item.$URL);
	};

	return (
		<ProductGalleryStoreContext.Provider value={galleryStore}>
			<DataGrid<C8Node>
				CardComponent={PPProductCardForValidation}
				SkeletonComponent={PPProductCardSkeleton}
				activeItemId={activeCardUrl}
				columns={1}
				design="list"
				onClickItem={_onClickCardItem}
				store={store}
			/>
		</ProductGalleryStoreContext.Provider>
	);
});

interface SetListItemProps extends ColorViolationSingleItemProps { }
const SetListItem: FunctionComponent<SetListItemProps> = (props) => {
	const { item } = props;

	return (
		<Box
			bgcolor={white[50]}
			borderRadius="3px"
			mx={5}
			my={4}
			p={4}
			pb={0}
		>
			<ColorViolationSingleItem item={item} />
		</Box>
	);
};

export interface PPValidationCenterProps { }
const PPValidationCenter: FunctionComponent<PPValidationCenterProps> = observer((props) => {
	const { invalidColorItems } = usePPValidationStore();

	return (
		<FlexRowCenter height={1} width={1}>
			<AccommodateScrollBarBox
				flexShrink={0}
				height="100%"
				layout="vertical"
				width={245}
			>
				<PPGallery />
			</AccommodateScrollBarBox>
			<Box
				flexGrow={1}
				height={1}
				overflow="auto"
				textAlign="center"
			>
				<FlexColumn
					bgcolor={grey[100]}
					borderRadius={3}
					flexGrow={1}
					ml={5}
					mt={5}
				>
					<Box mt={5} mx={5}>
						<PPResolution />
					</Box>
					{invalidColorItems?.map((item) => (
						<SetListItem
							item={item}
							key={item.url}
						/>
					))}
				</FlexColumn>
			</Box>
		</FlexRowCenter>
	);
});

export default PPValidationCenter;